export enum PaymentOrigins {
    Ecommerce = 1,
    Admin = 2
}
